import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { useLang } from "../i18n";

export default function Privacy() {
  const { t } = useLang();
  const p = t.privacy;
  return (
    <>
      <Seo title={p.seo.title} description={p.seo.description} path="/privacy-policy" />
      <section className="max-w-3xl mx-auto px-5 md:px-10 pt-32 md:pt-44 pb-20 md:pb-28">
        <Reveal>
          <p className="eyebrow mb-5">{p.eyebrow}</p>
          <h1 className="font-serif text-4xl sm:text-5xl leading-tight text-ink">{p.h1}</h1>
          <p className="mt-6 text-xs text-body">{p.updated}</p>
        </Reveal>
        {p.sections.map((s) => (
          <Reveal key={s.title}>
            <h2 className="font-serif text-2xl text-ink mt-12">{s.title}</h2>
            <p className="mt-4 text-sm md:text-base text-body leading-relaxed">{s.text}</p>
          </Reveal>
        ))}
      </section>
    </>
  );
}
